import React from 'react';
import { AddOnTile } from '@plans/tiles';
import {  prepareVDSTileProps } from './tileData';

const AddonsTile = (props) => <AddOnTile {...prepareVDSTileProps(props)} showBorder />;

export default AddonsTile;
